import React, { useState, useEffect } from "react";
import moment from "moment";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import api from "../../services/api";
import PageBar from "../../components/common/PageBar";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import CustomDatePicker from "../../components/common/CustomDatePicker";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import SearchInput from "../../components/common/SearchInput";

const LogManagementPage = () => {
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 15;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [startDate, setStartDate] = useState(
    moment().subtract(1, "year").toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());

  const [type, setType] = useState("");
  const [sbType, setSbType] = useState([{ code: "", codeDesc: t("L0031") }]);

  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState([]);

  const [creator, setCreator] = useState("");

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/log/view", {
        pageNo: curPage,
        pageSize: pageSize,
        logType: type,
        creId: creator,
        startDt: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        endDt: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      })
      .then((response) => {
        setDatas(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  useEffect(() => {
    api
      .post("/manage/log/type", {})
      .then((response) => {
        setSbType((prev) => [...prev, ...response.data]);
      })
      .catch(() => {});
  }, []);

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleDownload = async (id) => {
    try {
      const response = await api.post(
        "/manage/log/download",
        { id },
        { responseType: "blob" }
      );
      // Content-Disposition 헤더에서 파일명 추출
      let fileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Download failed");
    }
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const handleCreatorChange = (e) => {
    setCreator(e.target.value.trim());
  };

  const handleStartDateChange = (data) => {
    setStartDate(data);
    if (moment(data).isAfter(moment(endDate))) {
      setEndDate(data);
    }
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
    if (moment(data).isBefore(moment(startDate))) {
      setStartDate(data);
    }
  };

  const handleSearch = () => {
    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0074")]} />

      <SearchWrapDiv>
        <ButtonWrapDiv>
          {sbType.length > 0 && (
            <CodeSelectBox
              value={type}
              codes={sbType}
              onChange={handleTypeChange}
              multiple={false}
            ></CodeSelectBox>
          )}
          <SearchInput
            value={creator}
            onChange={handleCreatorChange}
            placeholder="Creator"
          ></SearchInput>
        </ButtonWrapDiv>
        <ButtonWrapDiv className="btn_right">
          <CustomDatePicker
            defaultDate={startDate}
            maxDate={new Date()}
            onChange={(date) => handleStartDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <div>
            <br />
            &nbsp;&nbsp;-&nbsp;&nbsp;
          </div>
          <CustomDatePicker
            defaultDate={endDate}
            maxDate={new Date()}
            onChange={(date) => handleEndDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "8%" }}></col>
              <col style={{ width: "10%" }}></col>
              <col style={{ width: "auto" }}></col>
              <col style={{ width: "15%" }}></col>
              <col style={{ width: "20%" }}></col>
              <col style={{ width: "10%" }}></col>
            </colgroup>
            <thead>
              <tr>
                <th>{t("L0130")}</th>
                <th>
                  {t("MENU:L0279")} {t("L0031")}
                </th>
                <th>
                  {t("MENU:L0279")} {t("L0142")}
                </th>
                <th>{t("L0115")}</th>
                <th>{t("L0104")}</th>
                <th>{t("L0322")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, index) => (
                  <tr key={data.id}>
                    <td>{(curPage - 1) * pageSize + index + 1}</td>
                    <td>{data.logType}</td>
                    <td>{data.fileName}</td>
                    <td>{data.creId}</td>
                    <td>{moment(data.creDt).format("YYYY-MM-DD a h:mm:ss")}</td>
                    <td>
                      <Link
                        to="#"
                        onClick={() => {
                          handleDownload(data.id);
                        }}
                      >
                        {t("L0322")}
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        />
      </LoadingBoxDiv>
    </div>
  );
};

export default LogManagementPage;
